/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function DrillIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="drill"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M3.5 18.75C3.5 17.784 4.284 17 5.25 17L11.75 17C12.716 17 13.5 17.784 13.5 18.75C13.5 19.716 12.716 20.5 11.75 20.5L5.25 20.5C4.284 20.5 3.5 19.716 3.5 18.75Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7 10L11 10L9.5 17L5.5 17L7 10Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.5 6.75C3.5 4.955 4.955 3.5 6.75 3.5L16.5 3.5L16.5 10L6.75 10C4.955 10 3.5 8.545 3.5 6.75Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16.5 5L18.25 5C19.216 5 20 5.784 20 6.75C20 7.716 19.216 8.5 18.25 8.5L16.5 8.5L16.5 5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20 6.75L22 6.75" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M10.25 13.5L12.633 13.5C13.576 13.5 14.391 12.841 14.589 11.919L15 10L11 10L10.25 13.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
